import client from "./http.client"
import store from "@/store"

class IntegrationService {
  async getIntegratedServices(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/`, { params })
  }
  async linkService(service_reference, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_reference}/link/`, { params })
  }
  async getService(service_id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/`, { params })
  }
  async getIntegration(service_id, params = {}) {
    // calls getService
    return this.getService(service_id,params)
  }
  async deactivateService(service_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/deactivate/`)
  }
  async allServices() {
    /* return as data json */
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/all-integrations/`)
  }
  async getServiceRealtimeUpdatesStatus(service_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/realtime-updates-status/`)
  }
  async revokeService(service_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/revoke/`)
  }
  async deleteService(service_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/delete/`)
  }
  async deleteSheet(service_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/delete-sheet/`, data)
  }
  async reSyncServiceObjects(service_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/resync/`, data)
  }
  async requestServiceDataPurge(service_id) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/request-data-purge/`)
  }
  async confirmServiceDataPurge(service_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/confirm-data-purge/`, data)
  }
  async updateServiceScope(service_id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/`, data)
  }
  async activateService(service_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/activate/`)
  }
  async filterServiceRecords(service_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/filter-records/`, data)
  }
  async setAccessToken(service_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/request-access-token/`, data)
  }
  async setOrgAccessToken(org_id, service_id, data) {
    return client.post(`/api/organizations/${org_id}/integrations/${service_id}/request-access-token/`, data)
  }
  async getServiceOwners(service_id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/get-owners/`, data, { params })
  }
  async updateServiceMapping(service_id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/mapping/`, data, { params })
  }
  async getAllServicesOwners() {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/get-owners/`)
  }
  async getServiceObjects(service_id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/objects/`, { params })
  }
  async getServiceRecord(service_id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/record/`, { params })
  }
  async getServiceMetaData(service_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/meta/`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }
  async getServiceMetaDataV2(service_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/meta/`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }
  async getServiceInfo(service_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/info/`)
  }
  async getServiceObject(service_id, params = { object_name: "" }) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/object/`, { params })
  }
  async createServiceMetrics(service_id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/create-metrics/`, data, { params })
  }
  async makeServicePublic(service_id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/make-public/`, data, { params })
  }
  startServiceSync(service_id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/start-sync/`, data, { params })
  }
  async stopServiceSync(service_id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/stop-sync/`, { params })
  }
  async abortSyncJob(service_id, job_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/abort-sync-job/?job_id=${job_id}`)
  }
  async reRunSyncJob(service_id, job_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/rerun-sync-job/?job_id=${job_id}`)
  }
  async getSyncStatus(service_id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/sync-status/`, { params })
  }
  async getSyncedGoogleSheets(service_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/synced/`)
  }
  // Add a contact to WhatsApp

  async getMetricsMapping() {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/metrics-mapping/`)
  }
  async callExternalServiceEndpoint(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/integrations/ext-service-call/`, data)
  }
  async callIntegrationExternalEndpoint(service_id, data, headers = {}) {
    const url = `/api/organizations/${store.state.organization.id}/integrations/${service_id}/ext-integration-call/`
    return client.post(url, data, { headers })
  }
  async verifyWhatsappNumber(service_id, code = null) {
    const data = {
      service_name: "whatsapp",
      action: "verify_whatsapp_number",
      data: {
        code: code
      }
    }
    return this.callIntegrationExternalEndpoint(service_id, data)
  }

  async getWhatsappMessageStatus(service_id, message_id) {
    const data = {
      service_name: "whatsapp",
      action: "get_whatsapp_message_status",
      data: {
        message_id: message_id
      }
    }
    return this.callIntegrationExternalEndpoint(service_id, data)
  }

  async sendWhatsappMessage(service_id, messageData, is_multipart_form = false) {
    const headers = is_multipart_form ? { "Content-Type": "multipart/form-data" } : { "Content-Type": "application/json" }

    let data = {
      service_name: "whatsapp",
      action: "send_whatsapp_message",
      data: messageData
    }

    if (is_multipart_form) {
      data = messageData
      //convert messageData to json data
      let jdata = {}
      for (let [key, value] of data.entries()) {
        jdata[key] = value
      }
      data.append("data", JSON.stringify(jdata))
    }

    return this.callIntegrationExternalEndpoint(service_id, data, headers)
  }
  async markWhatsappMessageAsRead(service_id, messageData) {
    const data = {
      service_name: "whatsapp",
      action: "mark_whatsapp_message_as_read",
      data: messageData
    }
    return this.callIntegrationExternalEndpoint(service_id, data)
  }
  async getWhatsappTemplates(service_id) {
    const data = {
      service_name: "whatsapp",
      action: "get_whatsapp_templates" // `action` should not be nested inside `data`
    }
    return this.callIntegrationExternalEndpoint(service_id, data)
  }

  async createWhatsappTemplate(service_id, templateData) {
    const data = {
      service_name: "whatsapp",
      action: "create_whatsapp_template",
      data: templateData // Use the provided template data directly
    }
    return this.callIntegrationExternalEndpoint(service_id, data)
  }

  async updateWhatsappTemplate(service_id, templateData) {
    const data = {
      service_name: "whatsapp",
      action: "update_whatsapp_template",
      data: templateData // Use the provided template data directly
    }
    return this.callIntegrationExternalEndpoint(service_id, data)
  }

  async deleteWhatsappTemplate(service_id, templateData) {
    const data = {
      service_name: "whatsapp",
      action: "delete_whatsapp_template",
      data: templateData // Use the provided template data directly
    }
    return this.callIntegrationExternalEndpoint(service_id, data)
  }

  /* Collaboration to get */
  async getChannelsAndUsers(service_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/integrations/${service_id}/channels-users/`)
  }
}

export default new IntegrationService()
